import { render, staticRenderFns } from "./AuditEnableScreenshotForm.vue?vue&type=template&id=0228b308&"
import script from "./AuditEnableScreenshotForm.vue?vue&type=script&lang=js&"
export * from "./AuditEnableScreenshotForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports